<div class="sprint-planning-details">
  <div class="details-header">
    <h4 class="details-title">Sprint plannings tras sprint reviews</h4>

    <div class="details-summary">
      @if (matchedCount() > 0) {
        <span class="summary-pill matched">
          <mat-icon>check_circle</mat-icon>
          {{ matchedCount() }} programado{{ matchedCount() === 1 ? '' : 's' }}
        </span>
      }

      @if (unmatchedCount() > 0) {
        <span class="summary-pill unmatched">
          <mat-icon>cancel</mat-icon>
          {{ unmatchedCount() }} sin programar
        </span>
      }
    </div>
  </div>

  @if (sprintPlannings().length === 0) {
    <p class="no-data">No hay sprint reviews programados en este período.</p>
  } @else {
    <div class="plannings-list">
      @for (row of sprintPlannings(); track row.sprint_review_date) {
        <div
          class="planning-row"
          [class.matched]="row.match_status === SprintPlanningExecutionMatchStatus.MATCHED"
          [class.unmatched]="row.match_status === SprintPlanningExecutionMatchStatus.UNMATCHED"
          [class.upcoming]="row.planning_status === EmployeeCalendarRegisterStatus.UPCOMING"
        >
          <div class="planning-main">
            <mat-icon class="planning-status-icon">
              @if (row.match_status === SprintPlanningExecutionMatchStatus.MATCHED) {
                <mat-icon>check_circle</mat-icon>
              } @else if (row.match_status === SprintPlanningExecutionMatchStatus.UNMATCHED) {
                <mat-icon>cancel</mat-icon>
              }
            </mat-icon>

            <div class="planning-main-text">
              <span class="planning-review-date"> Sprint review: {{ row.sprint_review_date | date: 'EEEE d LLL y' : '' : 'es-ES' }} </span>

              <span class="planning-deadline-label">
                Deadline planning: {{ row.sprint_planning_deadline | date: 'EEEE d LLL y' : '' : 'es-ES' }}
              </span>
            </div>
          </div>

          <div class="planning-meta">
            @if (row.planning_status === EmployeeCalendarRegisterStatus.NOT_SCHEDULED) {
              <span class="planning-result unmatched-result">
                <mat-icon>event_busy</mat-icon>
                Sin planning en deadline
              </span>
            } @else if (row.planning_status === EmployeeCalendarRegisterStatus.COMPLETED) {
              <span class="planning-result matched-result">
                <mat-icon>event_available</mat-icon>
                Planning realizado: {{ row.sprint_planning_date | date: 'd LLL y' : '' : 'es-ES' }}
              </span>
            } @else if (row.planning_status === EmployeeCalendarRegisterStatus.UPCOMING) {
              <span class="planning-result upcoming-result-scheduled">
                <mat-icon>event</mat-icon>
                Planning previsto: {{ row.sprint_planning_date | date: 'd LLL y' : '' : 'es-ES' }}
              </span>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
